import React from "react";
import { Container } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { BiArrowBack } from "react-icons/bi";
import { useTranslation, Trans } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
// import { useHistory } from "react-router-dom";
import "./template_01.css";

const Title = (props) => {
    const { desktopToggle, mobileToggle, id, disabledBackButton, onlyBackButton, desktopHeadingHide, mobileHeadingHide } = props;
    const { t } = useTranslation();
    const navigate = useNavigate();
    const isDesktopOrLaptop = useMediaQuery({
        query: '(min-width: 992px)'
    })

    if ((desktopToggle || mobileToggle) === true) {
        return (
            <>
                <section className={`section pageTitle font_h2 color_primary ${isDesktopOrLaptop ? 'desktop' : 'mobile'} ${desktopToggle ? "" : "d-lg-none"} ${mobileToggle ? "" : "d-none d-lg-block"}`} id={`${id}`}>
                    {!onlyBackButton ?
                        <>
                            {(desktopHeadingHide && mobileHeadingHide) ? <></> :
                                <Container className={` title_container  ${!desktopHeadingHide ? "" : "d-lg-none"} ${!mobileHeadingHide ? "" : "d-none d-lg-block"}`}>
                                    <Link className={` ${disabledBackButton && 'invisible'}`} onClick={() => navigate(-1)}><BiArrowBack /></Link>
                                    <div>{t(props.title)}</div>
                                </Container>
                            }
                            {props.desc &&
                                <div className="container desc_container font_h4 d-none d-lg-block">
                                    <Trans i18nKey={props.desc} components={{ tncLink: <a href="/help#term-and-conditions">tnc</a>, faqLink: <a href="/help#faq">FAQ</a>  }} />
                                </div>
                            }
                        </> :
                        <>
                            <Container className="font_h2 title_container  title_back">
                                <Link className="color_text" onClick={() => navigate(-1)}><BiArrowBack className="me-2" />{t('back')}</Link>

                            </Container>

                        </>
                    }


                </section>

            </>

        );
    }

};



export default Title;